import { useQuery } from "@tanstack/react-query";
import {
  TGetUsersResponseData,
  TPermission,
  TPermissionKey,
} from "@agt/contract";
import { fetchWithAuth } from "@/lib/api";
import { checkApiError } from "@/lib/helpers/format-api-error";

const API_URL = import.meta.env.VITE_API_URL;

export function useGetProfile() {
  return useQuery({
    queryKey: ["profile"],
    queryFn: async (): Promise<TGetUsersResponseData> => {
      const url = new URL(`${API_URL}/api/users/me`);

      try {
        const response = await fetchWithAuth(url.toString(), {
          method: "GET",
        });

        checkApiError(response);

        const result = await response.json();
        return result;
      } catch (error) {
        if (error instanceof Error && error.name === "UnauthorizedError") {
          console.log("Redirecting due to unauthorized access.");
        }
        console.error("Error fetching users:", error);
        throw error instanceof Error
          ? error
          : new Error("An unknown error occurred while fetching users");
      }
    },
  });
}

export function useGetProfilePermissions(): Record<TPermissionKey, boolean> {
  const { data: profile } = useGetProfile();
  const permissions = Object.fromEntries(
    (profile?.permissions as TPermission)?.map((p) => [
      p as TPermissionKey,
      true,
    ]) ?? [],
  ) as Record<TPermissionKey, boolean>;

  return permissions;
}
